export default function translate(i18n, propriete) {
  if (propriete === 'impressionAfficheProduitId') {
    return i18n.t('validation.impressionAfficheProduitId');
  }
  if (propriete === 'libelle') return i18n.t('addEditTypeOt.errors.libelle');
  if (propriete === 'actionInterventionOt') return i18n.t('addEditTypeOt.errors.actionIntervention');
  if (propriete.indexOf('tachesTypeOt') === 0) {
    const msgs = propriete.split('.');
    if (msgs[1] === 'Libelle') return i18n.t('addEditTypeOt.errors.libelleTache');
    if (msgs[1] === 'Description') return i18n.t('addEditTypeOt.errors.libelleDescription');
  }
  return propriete;
}
